import apiClient from 'api';
import { filterForAllowedProperties } from 'utils/format';
import { fetchAllFromMonitorServer } from 'api/common';

const monitorApiBaseUrl = window.env.REACT_APP_MONITOR_API_PATH;
const northgateApiBaseUrl = window.env.REACT_APP_NORTHGATE_API_PATH;

export const allowedAggregatorsProperties = [
  'aggregatorId',
  'lfdi',
  'sfdi',
  'registrationPin'
];

export const fetchAllAggregators = async (queryParams = {}) => {
  const aggregators = await fetchAllFromMonitorServer(
    'aggregator',
    ['start', 'limit'],
    queryParams
  );
  return aggregators.map(aggregator =>
    filterForAllowedProperties(aggregator, allowedAggregatorsProperties)
  );
};

export const fetchAggregatorById = async aggregatorId => {
  return await apiClient.get(monitorApiBaseUrl, `/aggregator/${aggregatorId}`);
};

export const edit = async (updatedAggregator, aggregatorId) => {
  return await apiClient.put(
    northgateApiBaseUrl,
    `/aggregator/${aggregatorId}`,
    updatedAggregator
  );
};

export const remove = async aggregatorId => {
  return await apiClient.delete(
    northgateApiBaseUrl,
    `/aggregator/${aggregatorId}`
  );
};

export const create = async newAggregator => {
  return await apiClient.post(
    northgateApiBaseUrl,
    `/aggregator`,
    newAggregator
  );
};
